module.exports = __webpack_public_path__ + "img/whatsapp_2.5daf332.svg";